import React from 'react';
import { PlusCircle } from 'lucide-react';
import { useResponsive } from '../../contexts/ResponsiveContext';

const CommunityPageHeader = ({ onNewPost }) => {
  const { isMobile } = useResponsive();

  return (
    <div className={`relative mb-6 ${isMobile ? 'pt-10' : ''}`}>
      {!isMobile && (
        <button
          type="button"
          onClick={onNewPost}
          className="absolute top-0 right-0 inline-flex items-center gap-1.5 px-4 py-2.5 rounded-xl text-sm font-medium bg-red-600 hover:bg-red-700 text-white shadow-sm transition-colors"
        >
          <PlusCircle className="w-4 h-4 shrink-0" />
          New Post
        </button>
      )}

      <div className="text-center">
        <h1 className="text-3xl font-bold tracking-tight text-gray-900 dark:text-gray-100">Community</h1>
      </div>
    </div>
  );
};

export default CommunityPageHeader;
